"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HorizontalBar = exports.default = undefined;

var _templateObject = _taggedTemplateLiteral(["\n  margin-top: 4px;\n"], ["\n  margin-top: 4px;\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var FixAlignmentContainer = _styledComponents2.default.div.withConfig({
  displayName: "Cross__FixAlignmentContainer",
  componentId: "sc-12h16xt-0"
})(_templateObject);

var CrossIcon = function CrossIcon(_ref) {
  var _React$createElement;

  var theme = _ref.theme;
  return _react2.default.createElement(
    FixAlignmentContainer,
    null,
    _react2.default.createElement(
      "svg",
      (_React$createElement = { xmlns: "http://www.w3.org/2000/svg",
        width: "24px",
        height: "24px",
        version: "1.1"
      }, _defineProperty(_React$createElement, "xmlns", "http://www.w3.org/2000/svg"), _defineProperty(_React$createElement, "xmlnsXlink", "http://www.w3.org/1999/xlink"), _defineProperty(_React$createElement, "viewBox", "0 0 24 24"), _React$createElement),
      _react2.default.createElement("line", { x1: "12", x2: "12", y2: "24",
        stroke: theme.colors.neutralLight,
        strokeWidth: "2", fill: "none",
        fillRule: "evenodd" }),
      _react2.default.createElement("line", { y1: "12", x2: "24", y2: "12",
        stroke: theme.colors.neutralLight,
        strokeWidth: "2", fill: "none",
        fillRule: "evenodd" })
    )
  );
};

exports.default = CrossIcon = (0, _styledComponents.withTheme)(CrossIcon);

var HorizontalBar = function HorizontalBar(_ref2) {
  var _React$createElement2;

  var theme = _ref2.theme;
  return _react2.default.createElement(
    FixAlignmentContainer,
    null,
    _react2.default.createElement(
      "svg",
      (_React$createElement2 = { xmlns: "http://www.w3.org/2000/svg",
        width: "24px",
        height: "24px",
        version: "1.1"
      }, _defineProperty(_React$createElement2, "xmlns", "http://www.w3.org/2000/svg"), _defineProperty(_React$createElement2, "xmlnsXlink", "http://www.w3.org/1999/xlink"), _defineProperty(_React$createElement2, "viewBox", "0 0 24 24"), _React$createElement2),
      _react2.default.createElement("line", { y1: "12", x2: "24", y2: "12",
        stroke: theme.colors.neutralLight,
        strokeWidth: "2", fill: "none",
        fillRule: "evenodd" })
    )
  );
};

exports.HorizontalBar = HorizontalBar = (0, _styledComponents.withTheme)(HorizontalBar);

exports.default = CrossIcon;
exports.HorizontalBar = HorizontalBar;


//////////////////
// WEBPACK FOOTER
// ./~/buoy-expandable-container/dist/images/Cross.js
// module id = 406
// module chunks = 168707334958949